//https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest

import { useRef, useEffect, useState, useCallback } from 'react'
import { debounce } from 'lodash'

const useAddressPredictions = (input, countryRestrictions) => {
  const [predictions, setPredictions] = useState([])
  const autocomplete = useRef()

  if (!autocomplete.current && window.google) {
    autocomplete.current = new window.google.maps.places.AutocompleteService()
  }

  const getPlacePredictions = input => {
    const predictionsConfig = {
      input,
    }
    if (countryRestrictions?.length !== 0)
      predictionsConfig.componentRestrictions = { country: countryRestrictions }

    autocomplete?.current &&
      autocomplete.current.getPlacePredictions(
        predictionsConfig,
        (predictions, status) => {
          if (status === 'OK') {
            setPredictions(predictions)
          }
        },
      )
  }

  const debouncedGetPlacePredictions = useCallback(
    debounce(getPlacePredictions, 500),
    [],
  )
  useEffect(() => {
    debouncedGetPlacePredictions(input)
  }, [input])
  return predictions
}

export default useAddressPredictions
